import $ from 'jquery';
import Backbone from 'backbone';
import Global from 'models/Global';
import notificationMessageTemplate from 'hbars!templates/notificationMessage';
import Person from 'models/Person';

var NotificationMessageView = Backbone.View.extend({
    className: 'notification-message-wrapper',

    initialize: function() {
        this.listenTo(this.model, 'change', this.render);
    },

    setActionButton: function() {
        var event = Global.get('event');
        var contentType = this.model.get('contentType');
        var actionButtonWrapper = this.$('.notification-message-action-wrapper');
        var downloadButtonWrapper = this.$('.notification-message-download-wrapper');
        var actionButton = this.$('.notification-message-action');

        if (this.model.get('action') == 'person' || contentType == 'connection_checkedin_to_rsvp_target') {
            var personId = this.model.get('triggered-by');
            var widgetParam = (Global.get('isWidget') ? '?widget=true' : '');
            actionButtonWrapper.removeClass('hide');
            actionButton.find('span').text('View Profile');
            actionButton.attr('href', event.getPublicWebsiteBaseUrl() + '/person/' + personId + widgetParam);
        } else if (contentType == 'reminder_to_checkin' || contentType == 'download_notification') {
            downloadButtonWrapper.removeClass('hide');
        }
    },

    render: function() {
        var html = notificationMessageTemplate(this.model.toJSON());
        this.$el.html(html);
        this.setActionButton();
        return this;
    }
});

export default NotificationMessageView;


